import React,{useEffect,useState} from 'react';
import './modal.scss'; 
import { IoClose } from "react-icons/io5";
import { useLocation } from 'react-router-dom';

const Modal = ({ isOpen, onClose, children }) => {
    const location = useLocation()
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        // Set initial width
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            {isOpen && (
                <div className="new_modal-overlay">
                    <div style={location.pathname.includes('admin') ? { width: '60vw', height: width < 1200 ? (width < 600 ? '30vh' : "50vh") : '80vh' } : { width: width > 768 ? "80%" : "95%", maxWidth: '700px' }} className="new_modal">
                        <span className="close mt-2" onClick={onClose}>
                        <IoClose color='red' size={27}/>
                        </span>
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};

export default Modal;

export const FormModel = ({ isOpen, onClose, children }) => {
    const location = useLocation()
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        // Set initial width
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            {isOpen && (
                <div className="new_modal-overlay">
                    <div style={{minWidth:'60%',maxWidth:'60%'}} className="new_modal">
                        <span  className="close" onClick={onClose}>
                        <IoClose color='red' size={27}/>
                        </span>
                        {children}
                    </div>
                </div>
            )}
        </>
    );
}
